/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.2.16 public/DUCATI.glb 
*/
import React, { useRef, useState, useEffect } from 'react'
import { useGLTF, useTexture } from '@react-three/drei'
import { useFrame } from '@react-three/fiber'
import { easing } from 'maath'
import { TextureLoader, MeshStandardMaterial, RepeatWrapping, MeshPhysicalMaterial, Color } from 'three';
import { cameraViewMatrix } from 'three/examples/jsm/nodes/Nodes.js';

export function Yacht_Hull_Dodatki({color1, fridge, backAdd, ...props}) {
  const { nodes, materials } = useGLTF('/yacht-dodatki.glb')
  const ref = useRef()

  const [currentColor, setCurrentColor] = useState(new Color(color1));

  const paint = new MeshStandardMaterial({
    color: currentColor,
    roughness: 0,
    metalness: 0.25,
  });

  useFrame((state, delta) => {
    const targetColor = new Color(color1);
    easing.dampC(currentColor, targetColor, 0.1, delta);
    setCurrentColor(currentColor.clone()); // Update state to trigger re-render
    if (ref.current) {
      ref.current.material.color.set(currentColor); // Update the material color directly
    }
  });

  return (
    <group {...props} dispose={null} scale={10}>
      {backAdd === 1 && (
      <mesh geometry={nodes.water_ski_.geometry} material={materials.chrome} />)}
      {backAdd === 2 && (
      <group position={[4.317, 0.418, 0]} scale={[0.02, 0.276, 0.02]}>
        <mesh geometry={nodes.Cylinder.geometry} material={materials.chrome} />
        <mesh geometry={nodes.Cylinder_1.geometry} material={materials['02___Default.003']} material-color={'#fff'}/>
      </group>)}
      {fridge === 1 && (
      <mesh geometry={nodes.bimini.geometry} material={paint} position={[3.013, 2.285, -1.024]} rotation={[0, 0, -0.074]} scale={[1.115, 0.029, 1]} />)}
    </group>
  )
}

useGLTF.preload('/DUCATI.glb')

